<template>
    <!-- <DxCheckBox :value="false" :name="checkBoxValue.name" :key="index" :ref="checkBoxValue.inputAttr.id"
        @value-changed="handleValueChange(checkBoxValue.inputAttr.id)" v-model="localValue" /> -->
    <DxCheckBox :name="checkBoxValue.name" :key="index" :ref="checkBoxValue.inputAttr.id" @valueChanged="onValueChange"
        v-model="localValue" :text="label" />
</template>

<script>
import { DxCheckBox } from 'devextreme-vue/check-box';
import {
    DxForm,
} from 'devextreme-vue/form';


export default {
    props: {
        checkList: Array,
        modelValue: {
            type: Array,
            default: [],
            required: true
        },

    },
    components: {
        DxCheckBox,
        DxForm,
    },
    data() {
        return {
            checkBoxValue: this.checkList.editorOptions,
            modelArr: [],
            checkBoxStatus: this.modelArr,
            localValue: this.modelValue
        }
    },
    watch: {
        modelValue(newVal) {
            this.localValue = newVal;
        }
    },
    methods: {
        onValueChange(e) {
            this.$emit("update:modelValue", e.value); // Emit updated checkbox value
        },

        // handleValueChange(id) {
        //     const newValue = this.$refs[id].instance.option("value");
        //     this.checkBoxStatus = newValue;

        //     // Create or update the object in modelArr
        //     const existingIndex = this.modelArr.findIndex(item => item.id === id);

        //     if (existingIndex !== -1) {
        //         // Update existing item
        //         this.modelArr[existingIndex].checkboxstatus = newValue;
        //     } else {
        //         // Add new item
        //         this.modelArr.push({ id: id, checkboxstatus: newValue });
        //     }

        //     console.log("modelArr is ", this.modelArr);
        //     this.$emit("update:modelValue", this.modelArr);
        // }
    },

    mounted() {
        console.log('value: ', this.checkList.editorOptions);
        // this.checkBoxValue = this.checkList;
        // console.log("checkList",this.checkList.editorOptions.checkList);
    },

}
</script>

<style></style>